import { IAppTheme } from '@msx/platform-services';

export const getStyles = (theme: IAppTheme) => {
    return {
      paraStyles: {
        margin: "10 0 10 0",
        padding: 0,
        fontSize: '16px',
      },
      cardGroupStyle: 
      { 
        display: "flex", 
        flexWrap: "wrap",
        justifyContent: "flex-start",
      },
      cardStyles: {
        width: 182,
        height: 286,
        margin: "10px",
        flex: '0 0 calc(50% - 20px)',
        maxWidth: "calc(50% - 20px)",
        borderRadius: "5px",
        boxShadow: '0px 2px 4px 0px #00000024',
      },
      imageStyles: {
        "&:hover": {
          opacity: 0.75,
        },
      },
      titleStyle: {
        fontSize: '14px',
        fontWeight: 600,
      },
      linkStyles: {
        textDecoration: "underline"
      },
    };
};


